import { render, staticRenderFns } from "./companyDocumentsComponent.vue?vue&type=template&id=77308dcd&"
import script from "./companyDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./companyDocumentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./companyDocumentsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports